import React, { useEffect, useState } from "react";
// import LazyLoad from 'react-lazyload';

import { exampleService } from "../../services/example.service";
import AddComment from "../Comment/AddComment";
import DisplayComment from "../Comment/DisplayComment";

import "../../pages/BudgetPage/BudgetPage.css";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CardContent from "@mui/material/CardContent";


import DeleteFile from "./DeleteFile";
import IsAdmin from "../IsAdmin/IsAdmin";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default function DisplayFiles(props) {
  const [filteredFiles, setfilteredFiles] = useState([]);
  const [comments, setComments] = useState();

  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(true);

  const { t } = useTranslation();

  const handleAllPodcasts = () => props.handleGetAllPodcasts();
  async function handleGetAllComments() {
    const response = await exampleService.getAllComments();
    setComments(response.data);
  }
  useEffect(() => {
    handleGetAllComments();
  }, []);


  useEffect(() => {
    setfilteredFiles(props.files.slice(0, endIndex));
  }, [props.files, endIndex]);


  
  const handleChange = (event) => {
    const searchResults = props.files.filter(
      (file) =>
        file.title && file.title.toLowerCase().includes(event.target.value)
    );

    setfilteredFiles(searchResults.slice(0, endIndex));
    setStartIndex(0);
    setEndIndex(5);
  };

  const handleLoadMore = () => {
    const nextEndIndex = endIndex + 5;
    if (nextEndIndex >= props.files.length) {
      setShowLoadMoreButton(false);
    }
    setStartIndex(endIndex);
    setEndIndex(nextEndIndex);
  };



  // i copied DisplayFile inside of it

  return (
    <>
      <input
        type="text"
        className="form-control mb-2 mr-sm-2"
        placeholder="Type to search..."
        onChange={handleChange}
      />
      <ul className="list-group">
        {filteredFiles.length > 0 ? (
          filteredFiles.map((file) => (
            <Container
              maxWidth="sm"
              key={file._id}
              sx={{
                borderRadius: "5px",
                padding: "10px",
                marginBottom: "25px",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <CardContent sx={{ flex: "1 0 auto" }}>
                  <h3 className="subtitle">{file.title}</h3>
                </CardContent>
                <div className="Audio-file">
                  <Box
                    sx={{ display: "flex", alignItems: "center", pl: 1, pb: 1 }}
                  >
                  {/* <LazyLoad height={200} once>
                    </LazyLoad> */}
                    <audio src={file.file_URL} type={"audio"} controls />
                  </Box>
                </div>
                <p className="description">{file.description}</p>
                <IsAdmin>
                  <DeleteFile
                    handleAllPodcasts={handleAllPodcasts}
                    fileId={file._id}
                  />
                </IsAdmin>
                <DisplayComment
                  handleGetAllComments={handleGetAllComments}
                  fileId={file._id}
                  comments={comments}
                />
                <AddComment
                  handleGetAllComments={handleGetAllComments}
                  fileId={file._id}
                />
              </Box>
              <br></br>
            </Container>
          ))
        ) : (
          <li className="list-group-item">No results found.</li>
        )}
        {showLoadMoreButton && filteredFiles.length >= 5 && (
          <button className="btn btn-primary" onClick={handleLoadMore}>
            {t("loadmore")}
          </button>
        )}
      </ul>   
    </>
  );
}
